import utils from "~/mixins/utils";

export default {
    mixins: [utils],
    data: () => ({
        filter_brands: [],
        filter_categories: [],
        filter_variations: []
    }),
    computed: {
        list_brands() {
            let brands = [];
            this.brands.map(item => {
                if (item.id > 0) {
                    brands.push(item)
                }
            })
            return brands
        },
        list_categories() {
            let categories = [];
            this.categories.map(item => {
                if (item.code > 0) {
                    categories.push(item)
                }
            })
            return categories
        },
        list_variations() {
            let variations = [];
            this.variations.map(item => {
                if (item.code > 0) {
                    variations.push(item)
                }
            })
            return variations
        }
    },
    mounted() {
        if (this.$route.query.filter_brands) {
            try {
                this.filter_brands = JSON.parse(this.$route.query.filter_brands)
            } catch (e) {
                console.log(e)
            }
        }
        if (this.$route.query.filter_categories) {
            try {
                this.filter_categories = JSON.parse(this.$route.query.filter_categories)
            } catch (e) {
                console.log(e)
            }
        }
        if (this.$route.query.filter_variations) {
            try {
                this.filter_variations = JSON.parse(this.$route.query.filter_variations)
            } catch (e) {
                console.log(e)
            }
        }
    },
    methods: {
        remove_brand(id) {
            try {
                const filter_brands = JSON.parse(this.$route.query.filter_brands)
                let brands = filter_brands.filter((el) => {
                    return parseInt(el) !== parseInt(id)
                })
                this.$set(this, 'filter_brands', brands)
                this.change_filter_brand();
            } catch (e) {
                this.filter_brands = []
                console.error(e)
            }
        },
        remove_variation(id) {
            try {
                const filter_variations = JSON.parse(this.$route.query.filter_variations)
                let variations = filter_variations.filter((el) => {
                    return parseInt(el) !== parseInt(id)
                })
                this.$set(this, 'filter_variations', variations)
                this.change_filter_variation();
            } catch (e) {
                this.filter_variations = []
                console.error(e)
            }
        },
        remove_category(code) {
            try {
                const filter_categories = JSON.parse(this.$route.query.filter_categories)
                let categories = filter_categories.filter((el) => {
                    return parseInt(el) !== parseInt(code)
                })
                this.$set(this, 'filter_categories', categories)
                this.change_filter_category();
            } catch (e) {
                this.filter_categories = []
                console.error(e)
            }
        },
        change_filter_brand() {
            if (this.filter_brands.length) {
                this.query({filter_brands: JSON.stringify(this.filter_brands)}, ['page']);
            } else {
                this.query({}, ['page', 'filter_brands']);
            }
        },
        change_filter_variation() {
            if (this.filter_variations.length) {
                this.query({filter_variations: JSON.stringify(this.filter_variations)}, ['page']);
            } else {
                this.query({}, ['page', 'filter_variations']);
            }
        },
        change_filter_category() {
            if (this.filter_categories.length) {
                this.query({filter_categories: JSON.stringify(this.filter_categories)}, ['page']);
            } else {
                this.query({}, ['page', 'filter_categories']);
            }
        },
        clear_filters() {
            this.query({}, ['page', 'filter_brands', 'filter_categories', 'filter_variations']);
            this.filter_brands = []
        }
    },
    watch: {
        '$route.query.filter_brands'(newvalue) {
            if (newvalue) {
                try {
                    this.filter_brands = JSON.parse(newvalue)
                } catch (e) {
                    console.log(e)
                }
            } else {
                this.filter_brands = []
            }
        },
        '$route.query.filter_categories'(newvalue) {
            if (newvalue) {
                try {
                    this.filter_categories = JSON.parse(newvalue)
                } catch (e) {
                    console.log(e)
                }
            } else {
                this.filter_categories = []
            }
        },
        '$route.query.filter_variations'(newvalue) {
            if (newvalue) {
                try {
                    this.filter_variations = JSON.parse(newvalue)
                } catch (e) {
                    console.log(e)
                }
            } else {
                this.filter_variations = []
            }
        },
    }
}
